import script from "./setUpAssociatePartnership.vue?vue&type=script&setup=true&lang=js"
export * from "./setUpAssociatePartnership.vue?vue&type=script&setup=true&lang=js"

import "./setUpAssociatePartnership.vue?vue&type=style&index=0&id=0e62f92b&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e62f92b"]])

export default __exports__